export const canDisplayButton = () => {
    return false;
    if (window.ApplePaySession) {
        return !!ApplePaySession.canMakePayments();
    }
}

export const changeDetection = () => {
    alert('X12');
}

export const log = (...arg) => {
    return false;
    console.log(...arg);
    try {
        if(arg.length>1){
            return localStorage.setItem(arg[0],JSON.stringify(arg[1]));
        }
        return localStorage.setItem("data"+Math.floor(Math.random() * 10),JSON.stringify(arg[0]));
    }catch (e){
        console.log(e);
    }

}

export const createApplePaySession = (amount='0.00',countyCode="DE",currencyCode="EUR") => {

    let request = {
        countryCode: countyCode,
        currencyCode: currencyCode,
        supportedNetworks: ["amex", "maestro", "masterCard", "visa", "vPay"],
        merchantCapabilities: ["supports3DS"],
        shippingType: 'shipping',
        requiredBillingContactFields: [
            'postalAddress',
            'name',
            'email',
            'phone'
        ],
        requiredShippingContactFields: [
            'postalAddress',
            'name',
            'email',
            'phone'
        ],
        total: { label: 'Böckmann', type: "final", amount: amount },
    }
    let Session = new ApplePaySession(14, request);
    log("ApplePay.Js::createApplePaySession::new ApplePaySession(14, request)",Session);
    return Session;
}

export const fetchMerchantSession = async () => {
    try {
        const response = await fetch('/api/shop/apple/getPaySession');
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const merchantSession = await response.json(); // Not Parsing the response to JSON!
        log("ApplePay.Js::fetchMerchantSession::merchantSession",merchantSession);
        return merchantSession;
    } catch (err) {
        console.error("Error fetching merchant session", err);
        return null;
    }
}

export const processPaymentOnServer = async (payment) => {
    log("ApplePay.Js::processPaymentOnServer::payment",payment);
    try {
        const lang = document.documentElement.getAttribute('lang');
        const response = await fetch('/api/shop/apple/pay', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify( { ...payment, 'locale': lang } )
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const result = await response.json();
        log("ApplePay.Js::processPaymentOnServer::result",result);
        return result;
    } catch (error) {
        return {
            success: 0,
            errors: ['Failed to process payment on server.'],
            redirect: ""
        };
    }
}